module.exports = __webpack_public_path__ + "media/4x3/il-874270d6.svg";